import posthog from "posthog-js";
import { getEnvironment } from "../environment";
import type { ProfileResource } from "./profile-types";

/**
 * Tracks profile identity for analytics.
 * Sends the profile id and non-identifying properties only. A `ProfileResource` is a Practitioner
 * or a Patient, so the name and the email on it can be patient PHI. Keep both off the person
 * profile; the id resolves the person when an operator needs it.
 */
export function identifyProfile(profile: ProfileResource): void {
  if (!profile.id) {
    return;
  }

  posthog.identify(profile.id, {
    role: profile.resourceType === "Practitioner" ? "provider" : "member",
    environment: getEnvironment().name,
  });
}
